import { ApiError } from '../api/client'

/** `ApiError.message` is a generic "API error 409"; the reason the operator
 *  needs ("check 101 from account 57469168 has already been recorded") is in
 *  `.detail`. Same unwrapping as PromoCodes.tsx, including the array shape
 *  FastAPI uses for a 422. */
export function describeError(err: unknown): string {
  if (err instanceof ApiError) {
    if (typeof err.detail === 'object' && err.detail !== null) {
      const d = (err.detail as Record<string, unknown>).detail
      if (typeof d === 'string') return d
      if (d && typeof d === 'object' && typeof (d as { message?: unknown }).message === 'string') {
        return (d as { message: string }).message
      }
      if (Array.isArray(d)) {
        const first = d[0] as { msg?: string } | undefined
        if (first?.msg) return first.msg
      }
    }
    return err.message
  }
  return err instanceof Error ? err.message : 'Request failed'
}
